import { render, staticRenderFns } from "./ProgramFlowImageComponentView.vue?vue&type=template&id=4bbb4c8a&scoped=true"
import script from "./ProgramFlowImageComponentView.vue?vue&type=script&lang=js"
export * from "./ProgramFlowImageComponentView.vue?vue&type=script&lang=js"
import style0 from "./ProgramFlowImageComponentView.vue?vue&type=style&index=0&id=4bbb4c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb4c8a",
  null
  
)

export default component.exports